;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { TourId } from "@/features/onboarding-tours/types/tour-definition";

export interface ObjectivesState {
	hasDataProvider?: boolean;
	hasInvitedMember?: boolean;
}

export interface TourRunRecord {
	completedAt?: string;
	dismissedAt?: string;
}

export type TourRunsState = Partial<Record<TourId, TourRunRecord>>;

export interface PipelineState {
	phaseIndex: number;
	guardHandoffDone: boolean;
	settingsTourDone: boolean;
}

export interface OnboardingToursStorageValue {
	objectives: ObjectivesState;
	tourRuns: TourRunsState;
	pipeline: PipelineState;
}

export const DEFAULT_PIPELINE_STATE: PipelineState = {
	guardHandoffDone: false,
	phaseIndex: 0,
	settingsTourDone: false,
};

export const DEFAULT_ONBOARDING_TOURS_STORAGE: OnboardingToursStorageValue = {
	objectives: {},
	pipeline: DEFAULT_PIPELINE_STATE,
	tourRuns: {},
};
